import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CategoryChildRequest, CategoryParentRequest, CategoryResponse } from 'src/app/models/category.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CategoryService } from 'src/app/services/category.service';
import { concatMap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  categorySelected = null;
  categories: CategoryResponse[] = [];
  creating = false;
  edit = 0;
  newCategory: CategoryParentRequest = new CategoryParentRequest();
  newCategoryChild: CategoryChildRequest = new CategoryChildRequest();
  newCategoryChildren: CategoryChildRequest[] = [];
  alwaysCreating = false;
  editing: {[key:number]:boolean} = {};

  constructor(
    private inventoryService: CategoryService,
    private toastService: ToastrService
  ) {

  }

  addCategoryChild() {
    this.newCategoryChildren.push(this.newCategoryChild);
    this.newCategoryChild = new CategoryChildRequest();
  }

  deleteNewCategoryChild(index: number) {
    this.newCategoryChildren.splice(index, 1);
  }

  addNewFamily() {
    this.inventoryService.postCategory(this.newCategory).pipe(
      concatMap((response: ResponseObject) => {
        var temp = response.data as CategoryResponse;
        const observables = this.newCategoryChildren.map(category => {
          category.parent = temp.id;
          return this.inventoryService.postCategory(category);
        });
        return observables.reduce((acc, obs) => acc.pipe(concatMap(() => obs)), of(null));
      })
    ).subscribe(
      () => {
        // Todas las llamadas al servicio se completaron con éxito
        this.toastService.success('Todas las familias fueron agregadas con éxito');
        this.getCategories();
      },
      (error: any) => {
        // Se produjo un error en alguna llamada al servicio
        this.toastService.error("Error al crear la familia");
      }
    );

  }

  resetNewFamily() {
    this.newCategory = new CategoryParentRequest();
    this.newCategoryChild = new CategoryChildRequest();
    this.newCategoryChildren = [];
  }

  cancelNewFamily(){
    if (!this.alwaysCreating){
      this.creating=false
    } 
    this.resetNewFamily();
  }

  ngOnInit(): void {
    this.getCategories();
  }

  getCategories() {
    this.inventoryService.getCategories().subscribe({
      next: (response: ResponseObject) => {
        this.categories = response.data as CategoryResponse[];
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener las categorias, por favor recarga la página");
      }
    })
  }

  editAndSave(category: any) {
    if (this.edit == category.id) {
      console.log(category);
      
      if (this.editing[category.id]){
        return;
      }
      this.editing[category.id] = true;
      this.inventoryService.updateCategory(category.id, category).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Categoría modificada correctamente");
          delete this.editing[category.id];
        },
        error: (error: any) => {
          delete this.editing[category.id];
          this.toastService.error("Error al modificar la categoria");
        }
      })
      this.edit = 0;
    } else {
      this.categorySelected = category.id;
      this.edit = category.id;
    }
  }

  addNewSubfamily(children){
    children.push({name:'',description:'',active:true})
  }

  activeOrInactive(category: any) {
    this.inventoryService.deleteCategory(category.id).subscribe({
      next: (response: any) => {
        category.active = !category.active;
        this.toastService.success("Se ha " + ((category.active) ? 'activado' : 'desactivado') + " correctamente la familia");
      },
      error: (error: any) => {
        this.toastService.success("Error al " + (category.active) ? 'desactivar' : 'activar' + " la familia");
      }
    })
  }
}
